import type { PaigeClient } from '@paige/api-client';
import type { EngagementApi } from './data-source';
import { tenantHeader, unwrap } from './http';

const h = (tenant: string) => ({ params: { header: tenantHeader(tenant) } });

/**
 * The person's engagement record in a company (`/me/engagement`, docs/engineering/engagement.md), as the dashboard
 * reads it: whether a one-time pointer was closed. The workbench keeps the same record through its own channel.
 */
export function engagementApi(client: PaigeClient): EngagementApi {
  return {
    async get(tenant) {
      return unwrap(await client.GET('/me/engagement', h(tenant)));
    },
    async closeHint(tenant, id) {
      const now = unwrap(await client.GET('/me/engagement', h(tenant)));
      const closed = [...new Set([...now.hints.closed.map((hint) => hint.id), id])];
      return unwrap(
        await client.PUT('/me/engagement/hints', {
          ...h(tenant),
          body: { show: now.hints.show, closed },
        }),
      );
    },
  };
}
